var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6074 3.9668C39.6977 3.96706 43.0135 7.28367 43.0137 11.374L43.0049 11.71C43.0104 11.6037 43.0137 11.4963 43.0137 11.3887V37.3623C43.0135 41.0462 39.8085 44.0332 35.8555 44.0332H12.1719C8.21881 44.0332 5.01388 41.0462 5.01367 37.3623V11.9893C5.00728 11.9116 5.00008 11.8332 4.99609 11.7549L4.98633 11.374C4.98646 7.41141 8.09841 4.17505 12.0117 3.97656L12.3936 3.9668H35.6074ZM17 22.0957V30.9707C17.0001 39.1369 30.9999 39.1385 31 30.9707V22.0957H27.3066L27.3057 30.3545C27.3057 34.3465 20.6934 34.5188 20.6934 30.3545V22.0957H17ZM12.3936 5.9668C9.40758 5.9668 6.98646 8.38808 6.98633 11.374C6.98679 14.3597 9.40778 16.7803 12.3936 16.7803H35.6074C38.593 16.78 41.0132 14.3595 41.0137 11.374C41.0135 8.38824 38.5932 5.96706 35.6074 5.9668H12.3936Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceB);
export default __webpack_public_path__ + "static/media/service_b.9de2405ee0c9a17db741208e6b25aed6.svg";
export { ForwardRef as ReactComponent };